/**
 * Hybrid Input Component
 * Automatically chooses between the Tailwind/CSS-class implementation (preferred,
 * better performance) and the styled-components implementation (for consumers
 * using system props or a styled() extension), based on props.
 *
 * Input uses an `innerRef` prop rather than forwardRef, so both paths receive it
 * through props — no forwardRef wrapper is introduced here.
 */
import * as React from "react";
import { hasStyledProps } from "@sproutsocial/seeds-react-system-props";
import type { TypeInputProps } from "./InputTypes";
import InputStyledComponents from "./InputStyledComponents";
import InputTailwind from "./InputTailwind";
import { ClearButton } from "./shared";

type TypeInputComponent = ((props: TypeInputProps) => React.ReactElement) & {
  displayName?: string;
  ClearButton: typeof ClearButton;
};

const InputHybrid: TypeInputComponent = Object.assign(
  (props: TypeInputProps) =>
    hasStyledProps(props) ? (
      <InputStyledComponents {...props} />
    ) : (
      <InputTailwind {...props} />
    ),
  { ClearButton }
);

InputHybrid.displayName = "Input";

export default InputHybrid;
